import { Component as BaseComponent, h } from 'preact';
import { connect } from 'preact-redux';
import moment from 'moment';

class Component extends BaseComponent {
    render({ class: className, url }) {
        return (
            <date-picker>
                <input
                  class={className}
                  url={url}
                />
            </date-picker>
        );
    }

    componentDidMount() {
        const selector = `input.${this.props.class.replace(' ', '.')}`;
        const url = this.props.url;

        $(selector).datepicker({
            dateFormat: 'yy-mm-dd',
            minDate: moment().subtract(30, 'days').format('YY-MM-DD'),
            maxDate: moment().add(2, 'days').format('YY-MM-DD'),
            onSelect: function(date) {
                window.location = url.replace(':date', date);
            },
        });
    }
}

export default connect()(Component);



// WEBPACK FOOTER //
// ./app/components/date-picker.js